import React from 'react';
import { TranslateFunction } from '@hooks/useTranslations';
import { IMySavedDeal } from '../../../../redux/user/user.duck.interface';
import { useDateUtils } from '@utils/Date.utils';
import useTranslations from '@hooks/useTranslations';

const renderDate = (date: Date): React.ReactNode => {
    const { t } = useTranslations();
    const { FormattedDate } = useDateUtils();
    return <FormattedDate date={date} formatString={t('dateFormat.myAccount')} />;
};

const renderExpiration = (expiryDate: Date, endDate: Date, t: TranslateFunction) => {
    const currentDate: Date = new Date();

    if (currentDate > expiryDate) {
        return (
            <p className="deal-expiration">
                {t('myaccount.carPreview.expiration')} {renderDate(endDate)}
            </p>
        );
    }

    return (
        <p className="deal-expiration">
            {t('myaccount.carPreview.expiredOn')} {renderDate(endDate)}
        </p>
    );
};

const renderLastSaved = (lastSaved: Date, t: TranslateFunction) => (
    <p className="deal-saved-text">
        {t('myaccount.carPreview.lastSaved')} {renderDate(lastSaved)}
    </p>
);

export const renderOrderExpiration = (deal: IMySavedDeal, t: TranslateFunction) => {
    if (!deal) return;

    if (deal.startDate && deal.endDate) {
        return <div>{renderExpiration(new Date(deal.endDate), deal.endDate, t)}</div>;
    }

    return <div>{renderLastSaved(deal.updated, t)}</div>;
};
